import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import bottleInventory from "./bottle-inventory.json";
import checkout from "./checkout.json";
import emailAddresses from "./email-addresses.json";
import favorites from "./favorites.json";
import gasMixtureConfigurator from "./gas-mixture-configurator.json";
import orders from "./orders.json";
import palletConfigurator from "./pallet-configurator.json";
import product from "./product.json";
import quickOrder from "./quick-order.json";
import refrigerantManagement from "./refrigerant-management.json";
import returnGas from "./return.json";
import shared from "./shared.json";
import shippingAddresses from "./shipping-addresses.json";
import shoppingCart from "./shopping-cart.json";
import start from "./start.json";

const gasShop = {
  ...getI18nJsonProp(base, "gasShop"),
  ...getI18nJsonProp(bottleInventory, "gasShop"),
  ...getI18nJsonProp(checkout, "gasShop"),
  ...getI18nJsonProp(emailAddresses, "gasShop"),
  ...getI18nJsonProp(favorites, "gasShop"),
  ...getI18nJsonProp(gasMixtureConfigurator, "gasShop"),
  ...getI18nJsonProp(orders, "gasShop"),
  ...getI18nJsonProp(palletConfigurator, "gasShop"),
  ...getI18nJsonProp(product, "gasShop"),
  ...getI18nJsonProp(quickOrder, "gasShop"),
  ...getI18nJsonProp(refrigerantManagement, "gasShop"),
  ...getI18nJsonProp(returnGas, "gasShop"),
  ...getI18nJsonProp(shared, "gasShop"),
  ...getI18nJsonProp(shippingAddresses, "gasShop"),
  ...getI18nJsonProp(shoppingCart, "gasShop"),
  ...getI18nJsonProp(start, "gasShop"),
};

export default gasShop;
